import React, { useEffect } from 'react';
import { useState } from 'react';
import { Divider, Form, Radio, CheckBox, Icon } from '@roo/roo';
import { OrganizationCert } from '../../applyView/innovate/baseinfo/organization';
import { renderDetailByColumns } from '../scientist/util';
import '../index.scss';

const { Group: RadioGroup } = Radio;

const creditCodeColumn = {
    label: '统一社会信用代码',
    key: 'creditCode'
};

const qualificationCertificateColumn = {
    label: '企业资质证书',
    key: 'qualificationCertificate',
    _render: item => {
        return (
            <OrganizationCert value={item}/>
        )
    }
};

const registerDateColumn = {
    label: '成立日期',
    key: 'registerDate'
};

const locationColumn = {
    label: '机构地址',
    key: 'location'
}

const legalPersonColumn = {
    label: '法定代表人',
    key: 'legalPerson'
}

const registeredCapitalColumn = {
    label: '注册资金',
    key: 'registeredCapital'
}

const getAgencyColumns = (orgType) => {
    if (orgType === 0) {
        return [creditCodeColumn, qualificationCertificateColumn, registerDateColumn, locationColumn, legalPersonColumn, registeredCapitalColumn];
    } else if (orgType === 1) {
        creditCodeColumn.required = false;
        legalPersonColumn.required = false;
        return [locationColumn, creditCodeColumn, legalPersonColumn];
    } else if (orgType === 2 || orgType === 5) {
        registeredCapitalColumn.required = false;
        return [creditCodeColumn, qualificationCertificateColumn, registerDateColumn, locationColumn, legalPersonColumn, registeredCapitalColumn];
    } else if (orgType === 3 || orgType === 4) {
        legalPersonColumn.required = false;
        registeredCapitalColumn.required = false;
        return [creditCodeColumn, qualificationCertificateColumn, registerDateColumn, locationColumn, legalPersonColumn, registeredCapitalColumn];
    }
    return [];
}


const staticAgencyColumns = [{
    label: '机构名称',
    key: 'organizationName'
}, {
    label: '机构类型',
    key: 'organizationType',
    _render: item => {
        return (
            <RadioGroup
              disabled
              value={item.organizationType}
            >
              <Radio value={0}>一般企业</Radio>
              <Radio value={1}>政府机关</Radio>
              <Radio value={2}>个体工商户</Radio>
              <Radio value={3}>事业单位</Radio>
              <Radio value={4}>社会团体</Radio>
              <Radio value={5}>其他机构</Radio>
            </RadioGroup>
        );
    }
}];

const manageColumns = [{
    label: '主营业务',
    key: 'mainBusiness'
}, {
    label: '经营范围',
    key: 'businessScope',
}, {
    label: '机构简介',
    key: 'organizationAbstract'
}];

const cols = { field: { span: 9, offset: 0, }, label: { span: 3 } }

export default ({ detail }) => {
    const { baseInfo } = detail;
    return baseInfo && (baseInfo.length > 0) ? baseInfo.map((item, index) => {
        const additionLabel = index === 0 ? '' : '联合';
        const additionKey = index === 0 ? '' : 'unit' + index;
        const agencyColumns = staticAgencyColumns.concat(getAgencyColumns(item.organizationType));
        return (
            <>
                <h3 id={`${additionKey}agency`} className='catalogue-tag'>{`${additionLabel}申报机构基础信息`}</h3>
                <Divider />
                {
                    renderDetailByColumns(item, agencyColumns, cols)
                }
                <h3 id={`${additionKey}manage`} className='catalogue-tag'>{`${additionLabel}机构经营信息`}</h3>
                <Divider />
                {
                    renderDetailByColumns(item, manageColumns, cols)
                }
            </>
        )
    }) : null
}